import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

/**
 * Custom PrimeNG Aura theme preset with Leasity blue as primary color
 * Extends the default Aura theme and overrides primary color tokens
 */
export const LeasityAuraPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#e9eeff',
      100: '#d6dffb',
      200: '#adbff7',
      300: '#859ef2',
      400: '#5c7eee',
      500: '#335eea', // Main Leasity blue
      600: '#294bbb',
      700: '#1f388c',
      800: '#14265e',
      900: '#0a132f',
      950: '#050818',
    },
    colorScheme: {
      light: {
        primary: {
          color: '#335eea',
          inverseColor: '#ffffff',
          hoverColor: '#294bbb',
          activeColor: '#1f388c',
        },
        highlight: {
          background: '#335eea',
          focusBackground: '#294bbb',
          color: '#ffffff',
          focusColor: '#ffffff',
        },
      },
      dark: {
        primary: {
          color: '#6271ff', // Leasity blue-light for dark mode
          inverseColor: '#ffffff',
          hoverColor: '#5c7eee',
          activeColor: '#859ef2',
        },
        highlight: {
          background: '#6271ff',
          focusBackground: '#5c7eee',
          color: '#ffffff',
          focusColor: '#ffffff',
        },
      },
    },
  },
});
